import * as React from "react";
import type { SVGProps } from "react";
const SvgInvoiceList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.998 16.002H13M15.875 16.127a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25M7.998 12H13"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.996 4.496v15.007a1 1 0 0 0 1.449.895l.771-.387a1 1 0 0 1 .894 0l1.774.887a1 1 0 0 0 .894 0l1.774-.887a1 1 0 0 1 .895 0l1.773.887a1 1 0 0 0 .896 0l1.771-.887a1 1 0 0 1 .896 0l.772.387a1 1 0 0 0 1.448-.895V4.496a1 1 0 0 0-1.449-.894l-.771.386a1 1 0 0 1-.895 0l-1.773-.886a1 1 0 0 0-.895 0l-1.773.886c-.282.14-.612.14-.894 0L9.78 3.102a1 1 0 0 0-.895 0l-1.772.886a1 1 0 0 1-.895 0l-.773-.386a1 1 0 0 0-1.448.894"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.875 12.125a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25M7.998 7.998H13M15.875 8.123a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25"
    />
  </svg>
);
export default SvgInvoiceList;
